// console.log('start fees-calc');
(function(){
    if($('.knowYLimits')[0]){
    let employed = true,
        empl = 15000,
        unem = 8000;
    if(getLimit() && !FE_CALC_NEW) {
        console.log(FE_CALC_NEW);
        empl = getLimit('CHE',1,0);
        unem = getLimit('CHE',4,0);

        chanQuLim(empl, false)
    }

    let limit = empl;

        $('#countSel li').click(function () {
            console.log($(this));
            let flag = $(this).data('fl'),
                val = $(this).text(),
                iso = $(this).data('iso'),
                $flag = $('#limFlag');

            empl = $(this).data('emp');
            unem = $(this).data('unemp');

            if(getLimit() && !FE_CALC_NEW) {
                // console.log('start api - ' + FE_CALC_NEW);

                empl = getLimit(iso,1,0);
                unem = getLimit(iso,4,0);

            }

            $flag.removeClass();
            $flag.addClass('flag-'+flag);

            $('#countSel .valdrop').html(val)
            $(this).parents('.drop-select').find('input').val(val);

            // console.log(val);

            (employed) ? limit = empl : limit = unem;

            if($('#verchek').prop('checked')) {
                chanQuLim($('#salary').val(), true)
            } else chanQuLim(limit, false)

        });
        $('#nature li').click(function () {
            if('Employed' === $(this).data('val')) {
                limit = empl;
                employed = true;
            } else {
                limit = unem;
                employed = false;
            }

            if($('#verchek').prop('checked')) {
                chanQuLim($('#salary').val(), true)
            } else chanQuLim(limit, false)
        });
        $('#verchek').on('change',function () {
            // console.log($(this).prop('checked'));

            if ($(this).prop('checked')) {
                $('.calc-hid').fadeIn(500)
            } else $('.calc-hid').fadeOut(100)

            if($(this).prop('checked')) {
                chanQuLim($('#salary').val(), true)
            } else chanQuLim(limit, false)
        });

        $('#salary').on('change keyup input',function () {
            if($('#verchek').prop('checked')) {
                let salVal = $('#salary').val();
                salVal = (salVal).replace(/[^0-9.]/g, '');
                let t = (salVal+'').split('.');
                // console.log(t.length);
                if(t.length>2) salVal = salVal.slice(0, - 1);
                $('#salary').val(salVal);
                chanQuLim(salVal, true)
            } else chanQuLim(limit, false)
        });

        $('.curr .toggle').on('hide.bs.dropdown',function () {
            chanQuLim($('#salary').val(), true)
        });
    }


    function chanQuLim(l, c = false) {

        // console.log(l);

        if(l){
            let t = (l+'').split('.');

            if (t[0]) {
                // console.log(t[0].length);
                if(t[0].length > 8){
                    t[0] = t[0].substr(0, 8);
                    let r;
                    if(t[1]) {
                        r = (t[0] + '.' + t[1]) * 1;
                        l = r;
                    } else {
                        r = (t[0]) * 1;
                        l = r;
                    }

                    $('#salary').val(r);
                }
            }
            if (t[1]) {
                // console.log(t[1].length);
                if(t[1].length > 2){
                    t[1] = t[1].substr(0, 2);
                    let r = (t[0] + '.' + t[1]) * 1;
                    l = r;
                    $('#salary').val(r);
                }
            }


            if(c) {
                if($('#cur').val()==='USD') {
                    // l = l * 4.5;
                    l = (l*4.5).toFixed(0)
                    l = (l + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
                    $('#yQrt').html(l)
                    // console.log(l);
                } else {
                    cPar = $('#cur').val() + '/USD';
                    $.ajax({
                        type: "GET",
                        url: 'https://www.dukascopy.com/api/forex-convert/' + cPar,
                        cache: false,
                        success: function (data) {
                            // console.log(l);
                            // console.log(data);
                            l = l * data * 4.5;
                            // console.log(l);
                            l = (l).toFixed(0)
                            l = (l + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
                            $('#yQrt').html(l)
                        },
                        error: function (jqXhr, textStatus, errorMessage) {
                            console.log('error', textStatus, errorMessage);
                        }
                    });
                }
            } else {
                l = (l).toFixed(0)
                l = (l + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
                $('#yQrt').html(l);
                // console.log(l);
            }
            // l = (l + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1,");

            // if (l.length>=9) {
            //     l = '~'+l.slice(0,-8)+'m';
            // } else if (l.length>=7) {
            //     l = '~'+l.slice(0,-4)+'k';
            // }
            // $('#yQrt').html(l);
            // console.log(l);
        }

    }


    function getLimit(iso = 'CHE',emp = 4,lim = 0) {
        let result = $.ajax({
            type: "GET",
            url: '/ajax.php?prc=getLimit&country='+iso+'&status='+emp+'&limit='+lim,
            cache: false,
            async: false,
            success: function (data) {
                // console.log(data);
                // console.log(data['DEFAULT_INCOMING_QUARTETLY_LIMIT']);
                // unem = data['DEFAULT_INCOMING_QUARTETLY_LIMIT'];
                // callback(data['DEFAULT_INCOMING_QUARTETLY_LIMIT'])
            },
            error: function (jqXhr, textStatus, errorMessage) {
                console.log('error', textStatus, errorMessage);
                return 'error';
            }
        });

        console.log(result);
        console.log(result.responseJSON);
        // console.log(result.responseJSON.DEFAULT_INCOMING_QUARTETLY_LIMIT);
        if (result.responseJSON === undefined || !result.responseJSON) {
            console.log('req error');
            return false;
        } else {
            console.log(result.responseJSON.DEFAULT_INCOMING_QUARTETLY_LIMIT);
            return result.responseJSON.DEFAULT_INCOMING_QUARTETLY_LIMIT * 1;
        }
    }

})();

// function decimalAdjust(type, value, exp) {
//     // Если степень не определена, либо равна нулю...
//     if (typeof exp === 'undefined' || +exp === 0) {
//         return Math[type](value);
//     }
//     value = +value;
//     exp = +exp;
//     // Если значение не является числом, либо степень не является целым числом...
//     if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
//         return NaN;
//     }
//     // Сдвиг разрядов
//     value = value.toString().split('e');
//     value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
//     // Обратный сдвиг
//     value = value.toString().split('e');
//     return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
// }
// // Десятичное округление к ближайшему
// if (!Math.round10) {
//     Math.round10 = function(value, exp) {
//         return decimalAdjust('round', value, exp);
//     };
// }
// // Десятичное округление вниз
// if (!Math.floor10) {
//     Math.floor10 = function(value, exp) {
//         return decimalAdjust('floor', value, exp);
//     };
// }
// // Десятичное округление вверх
// if (!Math.ceil10) {
//     Math.ceil10 = function(value, exp) {
//         return decimalAdjust('ceil', value, exp);
//     };
// }